import {generateInitialState} from "@/helpers/generateInitialState";
import {createSlice, isAnyOf} from "@reduxjs/toolkit";

const initialState = await generateInitialState("consultations", {});

const consultationsSlice = createSlice({
  name: "consultations",
  initialState,
  reducers: {
    setConsultations: (state, action) => {},
    updateConsultationsState: (state, action) => {
      const consultations = state.data;
      const consultation = action.payload;
      const index = consultations.findIndex(c => c.id === consultation.id);
      const newConsultations = consultations.map((c, i) => (i === index ? consultation : c));

      state.isFetching = false;
      state.hasFailed = false;
      state.errorMsg = "";
      state.data = newConsultations;
    },
  },
  extraReducers: builder => {},
});

export const {setConsultations, updateConsultationsState} = consultationsSlice.actions;
export default consultationsSlice.reducer;
